import React, {Component} from 'react';
import FilterItem from './FilterItem/FilterItem';

export default class Filters extends Component {
    constructor(props) {
        super(props);

        this.onActiveFilterUpdate = this.onActiveFilterUpdate.bind(this);
        this.getTotalPostCount = this.getTotalPostCount.bind(this);
        this.getCategoryTree = this.getCategoryTree.bind(this);
    }

    onActiveFilterUpdate(categoryId, categoryParentId) {
        let newActive = this.props.activeFilter === categoryId ? null : categoryId;
        this.props.activeFilterCallback(newActive, newActive ? categoryParentId: null)
    }

    getTotalPostCount(category, count) {
        let total = count + category.NumberOfArticles;

        if(category.Subcategory && category.Subcategory.length) {
            category.Subcategory.forEach(child => {
                total = this.getTotalPostCount(child, total);
            })
        }

        return total;
    }

    getCategoryTree(filter, index) {
        let postCount = this.getTotalPostCount(filter, 0);

        if(filter.Subcategory && filter.Subcategory.length) {
            let childList = (
                <React.Fragment>
                    <FilterItem name={"All " + filter.Name}
                                postCount={postCount}
                                isExpandable={false} key={'all-' + filter.Id}
                                categoryId={filter.Id}
                                categoryParentId={filter.ParentId}
                                isActive={this.props.activeFilter === filter.Id}
                                onActiveFilterUpdateCallback={this.onActiveFilterUpdate}/>
                    {filter.Subcategory.map((child, index) => {
                        return this.getCategoryTree(child, index);
                    })}
                </React.Fragment>
            );
            return (
                <FilterItem name={filter.Name} postCount={postCount}
                            isExpandable={true} key={'toggle-' + filter.Id}
                            id={filter.Id}
                            children={childList} />
            );
        } else {
            return (
                <FilterItem name={filter.Name} postCount={filter.NumberOfArticles}
                            isExpandable={false} key={'filter-' + filter.Id}
                            categoryId={filter.Id}
                            categoryParentId={filter.ParentId}
                            isActive={this.props.activeFilter === filter.Id}
                            onActiveFilterUpdateCallback={this.onActiveFilterUpdate} />
            );
        }
    }

    render() {
        return (
            <aside className="column secondary">
                <h2 className="boxHeading">
                    <span>
                        Filter by product type
                    </span>
                </h2>
                <ul className="post-feed__filters">
                    {this.props.filters.map((filter, index) => {
                        return this.getCategoryTree(filter, index);
                    })}
                </ul>
            </aside>
        );
    }
}